<template>
  <v-app id="app">
    <v-snackbar
      color="green"
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ text }}
      <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-navigation-drawer v-model="drawer" fixed app>
      <v-list>
        <v-list-tile @click="goHome()">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile>

        <v-list-group v-if="loggedIn" prepend-icon="settings">
          <v-list-tile slot="activator">
            <v-list-tile-title>Admin Settings</v-list-tile-title>
          </v-list-tile>
          
          <v-list-group sub-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-title>Advertiser</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-for="(advsr, i) in advertiser" :key="i" @click="routeHandler(advsr[2])">
              <v-list-tile-title v-text="advsr[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="advsr[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
          
          <v-list-group sub-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-title>Network</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-for="(nwrk, i) in network" :key="i" @click="routeHandler(nwrk[2])">
              <v-list-tile-title v-text="nwrk[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="nwrk[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-group sub-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-title>Country</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-for="(admin, i) in countries" :key="i" @click="routeHandler(admin[2])">
              <v-list-tile-title v-text="admin[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="admin[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-group sub-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-title>Operator</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-for="(oprt, i) in operator" :key="i" @click="routeHandler(oprt[2])">
              <v-list-tile-title v-text="oprt[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="oprt[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-group sub-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-title>Reports</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-for="(report, i) in reports" :key="i" @click="routeHandler(report[2])">
              <v-list-tile-title v-text="report[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="report[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-group sub-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-title>Settings</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-for="(setting, i) in settings" :key="i" @click="routeHandler(setting[2])">
              <v-list-tile-title v-text="setting[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="setting[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-group sub-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-title>Delete</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-for="(deleteAction, i) in deleteActions" :key="i" @click="routeHandler(deleteAction[2])">
              <v-list-tile-title v-text="deleteAction[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="deleteAction[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

        </v-list-group>
        <v-spacer></v-spacer>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-title>Deployed On- {{buildOn}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="blue" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <div style="display: flex;">
          <img height="30px" src="/static/img/icons/icon.png"/>
          <h1 class="title" style="margin-top: 5px;margin-left: 10px;">CLICK2MOBI</h1>
        </div>
      </v-toolbar-title>
    </v-toolbar>
    
    <v-content>
      <v-layout>
        <v-flex>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-content>

  </v-app>
</template>

<script>

  import axios from 'axios'
  import { SERVER_URL } from '@/constant.js'

  export default {
    name: "app",
    data: () => ({
      buildOn: '',
      loggedIn: true,
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      text: 'Success',
      drawer: false,
      countries: [
        ['Add/Remove Country', 'update', '/country/update']
      ],
      advertiser: [
        ['Add Advertiser', 'add', '/advertiser/add'],
        ['View Advertiser', 'list', '/advertiser/view'],
        ['Add Advertiser Url', 'add', '/advertiser/addUrl'],
        ['View Advertiser Urls', 'list', '/advertiser/viewUrls']
      ],
      operator: [
        ['Add Operator', 'add', '/operator/add'],
        ['View Operator', 'list', '/operator/view']
      ],
      network: [
        ['Add Network', 'add', '/network/add'],
        ['View Network', 'list', '/network/view'],
        ['Add Network Url', 'add', '/network/addUrl'],
        ['View Network Url', 'list', '/network/viewUrl'],
        ['Mannual Postback', 'send', '/network/manualPostback']
      ],
      reports: [
        ['Report Dashboard', 'dashboard', '/report/dashboard']
      ],
      settings: [
        ['Dollar', 'settings', '/setting/dollar']
      ],
      deleteActions: [
        ['Clicks', 'delete', '/delete/clicks'],
        ['Click Info', 'delete', '/delete/clickinfo']
      ]
    }),

    props: {
      source: String
    },
    created () {
      var vm = this;

      // To Display Operation Status.
      document.addEventListener('showSnackbarEvent', function(e) {
        vm.snackbar = true;
        vm.text = e.detail;
      })

      axios.get(`${SERVER_URL}/report/authorized`)
      .then(res => {
        if (res && res.data == 'success') {
          // LoggedIn.
          console.log("You are loggedIn.");
        } else {
          console.log("Login Required.");
          this.loginUrl = res.request.responseURL;
          this.loginRequired = true;
        }
      })

      axios.get(`${SERVER_URL}/version`)
      .then(res => {
        vm.buildOn = res.data;
      })

    },
    methods: {
      routeHandler(routeUrl) {
        this.drawer = false;
        this.$router.push(routeUrl)
      },
      goHome () {
        this.$router.push('/')
      },
      login () {
        window.location = window.origin + "/login";
      }
    }
  }

// {host=b1d4eb1b.ngrok.io, pragma=no-cache, cache-control=no-cache, x-wap-profile=http://218.249.47.94/Xianghe/MTK_Phone_KK_UAprofile.xml, accept=text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8, user-agent=Mozilla/5.0 (Linux; U; Android 7.0; zh-cn; Mi-4c Build/NRD90M) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/53.0.2785.146 Mobile Safari/537.36 XiaoMi/MiuiBrowser/9.4.11, x-requested-with=com.android.browser, accept-encoding=gzip, deflate, accept-language=th-TH,en-US;q=0.8, x-forwarded-for=122.155.35.85}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>





// WEBPACK FOOTER //
// src/App.vue